import { render, staticRenderFns } from "./CalculateTabs.vue?vue&type=template&id=bca7642e&scoped=true"
import script from "./CalculateTabs.vue?vue&type=script&lang=js"
export * from "./CalculateTabs.vue?vue&type=script&lang=js"
import style0 from "./CalculateTabs.vue?vue&type=style&index=0&id=bca7642e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca7642e",
  null
  
)

export default component.exports